export default {"src":"/_next/static/media/logo-text-white.4ceb6cc1.svg","height":78,"width":366};